"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalPriceCloserImpressionsList = void 0;
const React = require("react");
const bi_1 = require("react-icons/bi");
const gi_1 = require("react-icons/gi");
const general_impression_config_1 = require("../config/general-impression.config");
exports.HistoricalPriceCloserImpressionsList = [
    {
        id: 0,
        title: 'Paciência',
        subtitle: 'é fundamental',
        description: 'Este ativo está com um preço próximo ao preço máximo atingido dias atrás, talvez se esperar, consiga preços melhores.',
        icon: React.createElement(bi_1.BiCoffee, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 80,
        reportableIdentification: 'PRECO_PROXIMO_RESISTENCIA',
    },
    {
        id: 1,
        title: 'Pertinho',
        subtitle: 'da maior baixa',
        description: 'Este ativo está com um preço próximo de sua maior baixa dos últimos dias, talvez seja uma boa oportunidade de comprar.',
        icon: React.createElement(gi_1.GiPayMoney, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 80,
        reportableIdentification: 'PRECO_PROXIMO_BAIXA',
    },
];
//# sourceMappingURL=historical-price-closer-impressions.data.js.map